export default class newsManager {
    constructor(){

        this.$newsContent = $("#l-news__content");

    }
    open(_status){

        let _this = this;

        _status.Flg = true;

        TweenMax.fromTo(_this.$newsContent, .45, {
            x: '-10px',
            autoAlpha: 0,
            display: 'none'
        }, {
            x: 0,
            autoAlpha: 1,
            display: 'block',
            easing: Expo.easeOut
        });
        let _h = $('.headerglobalnavi').height()+20;
        TweenMax.killTweensOf($('.headerglobalnavi'));
        TweenMax.to($('.headerglobalnavi'), .25, {
            y:-_h,
            display:'none',
            easing:Expo.easeOut
        });

    }
    close(_status){

        let _this = this;

        TweenMax.to(_this.$newsContent, .45, {
            x: '-10px',
            autoAlpha: 0,
            display:'none',
            easing:Expo.easeOut,
            onComplete:function(){
                _status.Flg = false;
            }
        });
        TweenMax.to($('.headerglobalnavi'), .25, {
            y:0,
            display:'block',
            easing:Expo.easeOut
        });


    }
    set(_root,_path){
        if($('#l-news__content')[0]){
            $.getJSON(_root+_path+"news/news.json", function(data) {
                let i = 0;
                let _List = [];
                for ( i = 0; i < data.length; i++ ) {
                    if($(data)[i]['link'] !== ''){
                        _List[i] = '<li><a href="'+$(data)[i]['link']+'" target="_blank"><time>'+$(data)[i]['date']+'</time><p>'+$(data)[i]['content']+'</p></a></li>';
                        $('#l-news__list').append(_List[i]);
                    }else{
                        _List[i] = '<li><span><time>'+$(data)[i]['date']+'</time><p>'+$(data)[i]['content']+'</p></span></li>';
                        $('#l-news__list').append(_List[i]);
                    }
                }
                $('#l-news__trigger time').html($(data)[0]['date']);
                $('#l-news__trigger .text').html($(data)[0]['content']);
            });
        }
    }
}

